
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria/[slug]",
      function () {
        return require("private-next-pages/categoria/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categoria/[slug]"])
      });
    }
  